import React, { useEffect, useState } from "react";
import Layout from "../component/Layout";
import SubLayout from "../component/SubLayout";
import Header from "../component/Header";
import classes from "./SelectSubscription.module.css";
import { FaArrowLeft, FaCheck } from "react-icons/fa6";
import SmallLoader from "../component/SmallLoader";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setUserDetails } from "../store/slices/userSlice";
import { subApi } from "../http/http";

const SelectSubscription = () => {
  const [subscription, setSubscription] = useState(true);
  const [oneTimePurchase, setOneTimePurchase] = useState(false);
  const [dailyPack, setDailyPack] = useState(true);
  const [weeklyPack, setWeeklyPack] = useState(false);
  const [alias, setAlias] = useState("");
  const [loading, setLoading] = useState(false);
  const [flow, setFlow] = useState("");
  const [plan, setPlan] = useState(1);
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (location?.state?.alias) {
      console.log("alias in select sub:" + location?.state?.alias);
      setAlias(location?.state?.alias);
    } else {
      navigate("/");
    }
  }, [location]);

  const handleFormSubmission = async () => {
    try {
      setLoading(true);
      let pid = 1;
      if (subscription) {
        if (dailyPack) pid = 1;
        else pid = 2;
      } else if (oneTimePurchase) {
        if (dailyPack) pid = 3;
        else pid = 4;
      }
      setPlan(pid);
      const response = await subApi({
        action: 1,
        serviceId: 1,
        planId: pid,
        ani: "0",
        mode: "WAP",
        alias: alias,
      });
      setLoading(false);
      dispatch(setUserDetails(response?.data.data));
      setFlow("SUCCESS");
    } catch (error) {
      setLoading(false);
      console.log(error, "error---");
      toast.error(
        error?.response?.data?.message ||
          error?.response?.message ||
          error?.data?.message ||
          "Something Went Wrong!",
      );
    }
  };
  const redirectTo = async (input) => {
    if (input == "/home") window.location.href = "/home";
    else navigate(input);
  };

  return (
    <Layout>
      <SubLayout>
        <Header hide={true} />
        {flow === "SUCCESS" ? (
          <div className={classes.container}>
            <h3 className={classes.loginTitleGreen}>{t("success_" + plan)}</h3>
            <h3 className={classes.loginTitle}>{t("AccessService")}</h3>
            <div className={classes.btn_container}>
              <button
                className={classes.confirm_btn}
                type="button"
                onClick={() => {
                  redirectTo("/home");
                }}
              >
                {t("ClickHere")}
              </button>
            </div>
          </div>
        ) : flow === "CONFIRM" ? (
          <div className={classes.container}>
            <h3 className={classes.loginTitle}>{t("confirm_" + plan)}</h3>
            <h3 className={classes.loginTitleGreen}>{t("doubleConfirm")}</h3>

            {loading ? (
              <div
                style={{
                  width: "100%",
                  display: "grid",
                  placeContent: "center",
                }}
              >
                <SmallLoader />
              </div>
            ) : (
              <div className={classes.btn_container}>
                <button
                  type="button"
                  className={classes.confirm_btn}
                  disabled={loading}
                  onClick={handleFormSubmission}
                >
                  {t("YES")}
                </button>

                <button
                  type="button"
                  className={classes.back_button}
                  onClick={() => setFlow("")}
                >
                  <FaArrowLeft className={classes.back_icon} /> {t("NO")}
                </button>
              </div>
            )}
          </div>
        ) : (
          <div className={classes.container}>
            <div className={classes.packs}>
              <h2 className={classes.title}>{t("17")}</h2>
              <div className={classes.check_box_container}>
                <input
                  type="checkbox"
                  className={classes.check_box}
                  checked={subscription}
                  onChange={(e) => {
                    if (!subscription) {
                      setPlan(1);
                      setSubscription(e.target.checked);
                      setOneTimePurchase(false);
                      setDailyPack(true);
                      setWeeklyPack(false);
                    }
                  }}
                ></input>
                <label className={classes.check_box_label}>{t("18")}</label>
              </div>

              <div className={classes.check_box_container}>
                <input
                  type="checkbox"
                  className={classes.check_box}
                  checked={oneTimePurchase}
                  onChange={(e) => {
                    if (!oneTimePurchase) {
                      setPlan(3);
                      setOneTimePurchase(e.target.checked);
                      setSubscription(false);
                      setDailyPack(true);
                      setWeeklyPack(false);
                    }
                  }}
                ></input>
                <label className={classes.check_box_label}>{t("19")}</label>
              </div>
            </div>
            <div className={classes.packs}>
              <h2 className={classes.title}>{t("20")}</h2>
              <div className={classes.check_box_container}>
                <input
                  type="checkbox"
                  className={classes.check_box}
                  checked={dailyPack}
                  onChange={(e) => {
                    if (!dailyPack) {
                      if (!subscription) setPlan(3);
                      else setPlan(1);
                      setDailyPack(e.target.checked);
                      setWeeklyPack(false);
                    }
                  }}
                ></input>
                <label className={classes.check_box_label}>
                  {subscription ? t("21") : t("22")}
                </label>
              </div>

              <div className={classes.check_box_container}>
                <input
                  type="checkbox"
                  className={classes.check_box}
                  checked={weeklyPack}
                  onChange={(e) => {
                    if (!weeklyPack) {
                      if (!subscription) setPlan(4);
                      else setPlan(2);
                      setWeeklyPack(e.target.checked);
                      setDailyPack(false);
                    }
                  }}
                ></input>
                <label className={classes.check_box_label}>
                  {subscription ? t("23") : t("24")}
                </label>
              </div>
              <h3 className={classes.titlePack}>{t("pack_" + plan)}</h3>
            </div>

            {loading ? (
              <div
                style={{
                  width: "100%",
                  display: "grid",
                  placeContent: "center",
                }}
              >
                <SmallLoader />
              </div>
            ) : (
              <div className={classes.btn_container}>
                <button
                  type="button"
                  className={classes.confirm_btn}
                  disabled={loading}
                  onClick={() => setFlow("CONFIRM")}
                >
                  {t("25")}
                </button>

                <button
                  type="button"
                  className={classes.back_button}
                  onClick={() => navigate("/")}
                >
                  <FaArrowLeft className={classes.back_icon} /> {t("26")}
                </button>
              </div>
            )}
          </div>
        )}
      </SubLayout>
    </Layout>
  );
};

export default SelectSubscription;
